var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 363,
    viewBox: "0 0 233 363",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "left_down_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 233,
    height: 363
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h233v363H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#left_down_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6 551c58.015 0 104.289-35.097 133.707-78.994C157.352 427.77 174 369.632 174 308c0-61.632-16.648-119.77-46.293-164.006C98.289 100.097 52.015 65-6 65s-104.289 35.097-133.707 78.994C-169.352 188.23-186 246.368-186 308c0 61.632 16.648 119.77 46.293 164.006C-110.289 515.903-64.015 551-6 551z",
    stroke: "#3DAE86",
    strokeOpacity: 0.2,
    strokeWidth: 104
  }))));
}

export default __webpack_public_path__ + "./fonts/left_down.a1c2ec4f4cff4944177ff7e7b95f5ed4.svg";
export { SvgLeftDown as ReactComponent };